import React, { useState, useEffect } from 'react';
import '../../styles/ServicesPage/services.css';
import bgvideo from "../../assets/pageVideo.mp4";
import AboutSection from '../../components/AboutPage/AboutSection';

const reviews = [
  {
    title: "Product Design",
    rating: 5,
    description: "The team is exceptional. Their passion shines through every phase, resulting in a product exceeding expectations. We feel fortunate to have such a dedicated partner, always going the extra mile to ensure success.",
    reviewer: {
      name: "Jennifer White",
      designation: "Manager",
      image: "https://randomuser.me/api/portraits/women/44.jpg",
    }
  },
  {
    title: "UI/UX Expertise",
    rating: 4,
    description: "They consistently bring fresh, innovative ideas. Their dedication to quality and attention to detail ensures the result is visually appealing and user-friendly, helping us engage better with customers.",
    reviewer: {
      name: "Michael Brown",
      designation: "Lead Designer",
      image: "https://randomuser.me/api/portraits/men/32.jpg",
    }
  },
  {
    title: "Innovative Solutions",
    rating: 5,
    description: "Their creativity and problem-solving are unparalleled. They approach challenges with unique perspective, delivering innovative solutions that significantly enhance our business processes and outcomes.",
    reviewer: {
      name: "Sara Thompson",
      designation: "Product Owner",
      image: "https://randomuser.me/api/portraits/women/65.jpg",
    }
  },
  {
    title: "Timely Delivery",
    rating: 4,
    description: "The team respects deadlines and maintains proactive communication. Their ability to deliver on time without sacrificing quality has been a major asset for our schedules.",
    reviewer: {
      name: "David Lee",
      designation: "Project Manager",
      image: "https://randomuser.me/api/portraits/men/76.jpg",
    }
  },
  {
    title: "Great Communication",
    rating: 5,
    description: "Their transparent and consistent communication makes collaboration smooth and efficient. We always feel informed and involved, which builds trust and helps the project flow.",
    reviewer: {
      name: "Emily Clark",
      designation: "Marketing Head",
      image: "https://randomuser.me/api/portraits/women/12.jpg",
    }
  },
  {
    title: "Highly Recommended",
    rating: 5,
    description: "For anyone seeking quality, reliability, and a team that truly cares about client success, we highly recommend this group. Their professionalism and results-driven approach have impacted our projects.",
    reviewer: {
      name: "James Wilson",
      designation: "CEO",
      image: "https://randomuser.me/api/portraits/men/85.jpg",
    }
  },
  {
    title: "Attention to Detail",
    rating: 4,
    description: "Their meticulous focus on details during design and development is impressive. This dedication ensures a polished product offering seamless user experience and standing out in the market.",
    reviewer: {
      name: "Anna Martinez",
      designation: "QA Lead",
      image: "https://randomuser.me/api/portraits/women/54.jpg",
    }
  },
  {
    title: "Creative Team",
    rating: 5,
    description: "A highly creative team that understands client needs and turns those into outstanding, practical products. Their imaginative approach consistently produces fresh ideas that set us apart.",
    reviewer: {
      name: "Robert King",
      designation: "Business Analyst",
      image: "https://randomuser.me/api/portraits/men/41.jpg",
    }
  },
  {
    title: "Excellent Support",
    rating: 5,
    description: "Their post-project support has been invaluable. They are always available to assist with improvements, troubleshoot issues quickly, and provide guidance, ensuring our product performs well after launch.",
    reviewer: {
      name: "Laura Scott",
      designation: "Customer Success Manager",
      image: "https://randomuser.me/api/portraits/women/28.jpg",
    }
  },
  {
    title: "Strategic Thinking",
    rating: 4,
    description: "They bring strategic insight to every development phase, helping us make informed decisions. Their advice and vision have been instrumental in planning future growth and optimizing our roadmap.",
    reviewer: {
      name: "Mark Davis",
      designation: "Strategy Consultant",
      image: "https://randomuser.me/api/portraits/men/19.jpg",
    }
  }
];



function About() {
    const [currentReview, setCurrentReview] = useState(0);
  
    const heroBackgroundImage = "https://images.pexels.com/photos/3182747/pexels-photo-3182747.jpeg";
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentReview(prev => (prev + 1) % reviews.length);
      }, 2000);
      return () => clearInterval(interval);
    }, []);
  
    return (
      <>
        {/* Services Section */}
        <section id="services" className="services-page">
          {/* Hero Banner */}
          <div
            className="hero-banner services-banner"
            style={{
              backgroundImage: `url(${heroBackgroundImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              height: "500px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              color: "#fff"
            }}
          >
            <div className="overlay"></div>
            <div className="hero-content">
              <h1>About us</h1>
              <p>
                <span>Home</span> &nbsp;›&nbsp; <span className="active">About</span>
              </p>
            </div>
          </div>
  
          <AboutSection />
        </section>
  
        {/* Video Section with Floating Review Card */}
        <div className="video-container">
          <video autoPlay loop muted playsInline className="background-video">
            <source src={bgvideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-overlay"></div>
  
          {/* Floating Review Card */}
          <div className="floating-review-card">
            <div className="review-top-row">
              <h3 className="review-title">{reviews[currentReview].title}</h3>
              <div className="review-stars">
                {"★".repeat(reviews[currentReview].rating)}
                {"☆".repeat(5 - reviews[currentReview].rating)}
              </div>
            </div>
            <p className="review-description">{reviews[currentReview].description}</p>
            <div className="review-bottom">
              <img src={reviews[currentReview].reviewer.image} alt={reviews[currentReview].reviewer.name} className="review-avatar" />
              <div className="review-info">
                <strong>{reviews[currentReview].reviewer.name}</strong>
                <span>{reviews[currentReview].reviewer.designation}</span>
              </div>
            </div>
            <div className="review-dots">
              {reviews.map((_, idx) => (
                <span
                  key={idx}
                  className={`dot ${idx === currentReview ? 'active-dot' : ''}`}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </>
    );
  }
  

export default About;
